module.exports = __webpack_public_path__ + "img/bg1.99bc8186.png";